import { useProcessTableColumns } from "../../../context/ProcessTableContext";
import { DraggableColumnTitles } from "./DraggableColumnTitles";
import { ProcessTableColumnZod, SQLGeneratedProcess } from "@avenueops/shared-types";
import { SmartForm, Button } from "@avenueops/web-components";
import { Popover, PopoverTrigger, PopoverContent } from "@avenueops/web-components";
import { TableCellsIcon } from "@heroicons/react/24/outline";
import { Table } from "@tanstack/react-table";
import _ from "lodash";
import { FormProvider, useForm } from "react-hook-form";
import { TableRow } from "../ProcessTableUtils";

interface Props {
  table: Table<TableRow>;
}

export function ProcessTableColumnSelector({ table }: Props): JSX.Element {
  const formMethods = useForm();
  const { handleSubmit, setValue } = formMethods;
  const [processTableStateColumns, setProcessTableStateColumns] = useProcessTableColumns();

  const onSubmit = async (data: any, event: any) => {
    if (!data.dynamicColumn) {
      return;
    }
    const addedColumn = { id: `DYNAMIC_${data.dynamicColumn}`, visibility: true } as ProcessTableColumnZod;
    setProcessTableStateColumns([...processTableStateColumns, addedColumn]);
    setValue("dynamicColumn", undefined);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="SECONDARY" LeadIcon={TableCellsIcon} size="MEDIUM">
          Columns
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <FormProvider {...formMethods}>
          <div>
            <div className="border-b border-gray-300 pb-2">
              <div className="font-medium text-sm w-full items-center px-2 mb-2">Table Columns</div>
              <DraggableColumnTitles table={table} />
            </div>
            <div className="my-1">
              <div className="font-medium text-sm w-full px-2 pt-2 items-center">Dynamic data columns</div>
            </div>

            <div className="flex flex-row gap-2 w-full items-center place-items-center text-sm">
              <div>
                <SmartForm.TextInput name="dynamicColumn" placeholder="firstName" />
              </div>
              <Button type="SECONDARY" onClick={handleSubmit(onSubmit)}>
                Add
              </Button>
            </div>
          </div>
        </FormProvider>
      </PopoverContent>
    </Popover>
  );
}
